<template>
  <div class="radio-picture-select-attribute-editor">
    <label
      class="generic_editor_radio__label"
      :class="{
        'input__label--required': isRequired
      }"
    >
      {{ label }}
    </label>
    <div class="generic_editor_radio">
      <Field
        :name="name"
        :value="initialValue"
        :rules="rules ?? ''"
        v-slot="{ field, handleChange }"
        @change="changeHandler"
      >
        <label
          v-for="possibleValue in possibleValues"
          :key="possibleValue.id"
          class="generic_editor_radio__option"
          v-tooltip="possibleValue.pictureUrl ? possibleValue.description : ''"
          :for="`radio-${name}-${possibleValue.id}`"
        >
          <input
            :name="name"
            v-bind="field"
            :value="possibleValue.id"
            :id="`radio-${name}-${possibleValue.id}`"
            type="radio"
            class="radio-input__input"
            :checked="initialValue === possibleValue.id"
            @change="handleChange"
          >
          <img
            v-if="possibleValue.pictureUrl"
            class="generic_editor_radio__image"
            :src="possibleValue.pictureUrl"
            :alt="possibleValue.description"
          >
          <p class="generic_editor_radio__text">
            {{ possibleValue.id }}
          </p>
        </label>
      </Field>
    </div>
  </div>
</template>

<script>
import {Field} from "vee-validate";

export default {
  components: {
    Field,
  },
  props: {
    name: String,
    label: String,
    rules: [Object, String],
    possibleValues: Array,
    initialValue: String,
  },
  emits: ['change'],
  methods: {
    isRequired() {
      if (typeof this.rules === 'object') {
        return this.rules.required;
      }
      return this.rules?.includes('required');
    },
    changeHandler(event) {
      this.$emit('change', {value: event.target.value});
    },
  }
};

</script>
